import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asus_proart_sw_ico_cancel",
  "use": "asus_proart_sw_ico_cancel-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"asus_proart_sw_ico_cancel\"><g id=\"asus_proart_sw_ico_cancel_asus_proart_sw_ico_cancel\"><rect width=\"48\" height=\"48\" style=\"fill:none\" /><path d=\"M25.41,24l11.3,11.29-1.42,1.42L24,25.41,12.71,36.71l-1.42-1.42L22.59,24,11.29,12.71l1.42-1.42L24,22.59l11.29-11.3,1.42,1.42Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol